import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

interface ProtectedRouteProps {
  children: React.ReactNode
  /** If provided, show this instead of redirecting to login when unauthenticated */
  fallback?: React.ReactNode
}

export function ProtectedRoute({ children, fallback }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  if (!isAuthenticated) {
    if (fallback) return <>{fallback}</>
    return <Navigate to="/auth/login" replace />
  }
  return <>{children}</>
}
